import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactusComponent } from './contactus/contactus.component';
import { ProjectsComponent } from './projects/projects.component';
import { ServicesComponent } from './services/services.component';
import { LoginComponent } from './login/login.component';
import { AdminAuthGuardService } from './AppServices/app.adminguard';
import { AdminprojectsComponent } from './adminprojects/adminprojects.component';
import { AdminProjectListComponent } from './admin-project-list/admin-project-list.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';

const routes: Routes = [
  {path: 'Home', component: HomeComponent },
  {path: 'About', component: AboutComponent},
  {path: 'ContactUs', component: ContactusComponent},
  {path: 'Projects', component: ProjectsComponent},
  {path: 'Services', component: ServicesComponent},
  {path: 'Blog', component: BlogComponent },
  {path: 'Blog/:slug', component: BlogDetailComponent },
  {path: 'Login', component: LoginComponent },
  {path: 'Admin/Project/:id', component: AdminprojectsComponent, canActivate: [AdminAuthGuardService]},
  {path: 'Admin/Project', component: AdminprojectsComponent, canActivate: [AdminAuthGuardService]},
  {path: 'Admin/ProjectList/:updated', component: AdminProjectListComponent, canActivate: [AdminAuthGuardService]},
  {path: 'Admin/ProjectList', component: AdminProjectListComponent, canActivate: [AdminAuthGuardService]},
  { path: '', component: HomeComponent },
  { path: '**', component: HomeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
